import React, { useState } from 'react'
import languageDropdownIcon from '../../../../assets/languageDropdown.png'
import languagesImg from '../../../../assets/languages.png'
type Language = {
  code: string
  label: string
}

type LanguageSwitcherProps = {
  languages: Language[]
  selectedLanguage: string
  onChange: (langCode: string) => void
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  languages,
  selectedLanguage,
  onChange,
}) => {
  const [open, setOpen] = useState(false)

  const selected = languages.find((lang) => lang.code === selectedLanguage)

  return (
    <div className="relative inline-block text-left">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-2 rounded-full border border-white bg-gradient-to-r from-red-400  lg:px-4 lg:py-1 p-1 text-white text-sm focus:outline-none"
      >
        <img src={languagesImg} alt="DIC Logo" className="object-contain" />
        <div className="lg:block hidden">{selected?.label || 'Select'} </div>
        <img
          src={languageDropdownIcon}
          alt="DIC Logo"
          className="h-[20px] object-contain"
        />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-32 origin-top-right rounded-lg bg-white shadow-lg ring-1 ring-transparent ring-opacity-5 z-50">
          <div className="py-1">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => {
                  onChange(lang.code)
                  setOpen(false)
                }}
                className={`w-full px-4 py-2 text-sm text-left hover:bg-gray-100 ${
                  lang.code === selectedLanguage
                    ? 'bg-gray-100 font-medium'
                    : ''
                }`}
              >
                {lang.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default LanguageSwitcher
